import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import Datatable from "../../Constants/Datatable";
import { COLUMNS_RETIRED } from "../../Constants/DatatableColumns";
import { PaginationHeaderYear,validateTokenStorage } from "./../../Constants/Util";
import { Row, Col, Container, Button } from "reactstrap";
import { getRetiredPerson } from "../../Constants/Services";
import { IRetiredPerson } from "./../../Constants/Interfaces";
import ClipLoader from "react-spinners/ClipLoader";
import { css } from "@emotion/core";

const override = css`
  margin: 0 auto;
  position: relative;
  top: 10px;
  right: 10px;
`;

interface IRetiredState {
  dataRetired: IRetiredPerson[];
  year: string;
  loading: boolean;
}

class Retired extends Component<RouteComponentProps<{}>, IRetiredState> {
  constructor(props: any) {
    super(props);
    this.state = {
      dataRetired: [],
      year: new Date().getFullYear().toString(),
      loading: false,
    };

    this.fetchRetired = this.fetchRetired.bind(this);
    this.changeHeader = this.changeHeader.bind(this);
    this.rechargeData = this.rechargeData.bind(this);
  }

  async fetchRetired() {
    const year = this.state.year;
    const response = await getRetiredPerson(year);
    this.setState({
      dataRetired: response,
      loading: false,
    });
  }

  componentDidMount() {
    if(validateTokenStorage()){
      this.context.quitToken();
    }
    this.fetchRetired();
  }

  rechargeData() {
    this.setState({ loading: true });
    setTimeout(() => {
      this.fetchRetired();
    }, 1000);
  }

  changeHeader({ year, operation }: any) {
    var currentYear = new Date();

    var result = year;
    if (operation === "left") result = parseInt(year) - 1;
    else {
      result = parseInt(year) + 1;
      if (result > currentYear.getFullYear()) result = currentYear.getFullYear();
    }

    this.setState({
      year: result,
    });
    setTimeout(() => {
      this.fetchRetired();
    }, 1000);
  }

  render() {
    const props = this.state;
    return (
      <React.Fragment>
        <Container className="mt-4">
          <Row>
            <Col sm={12}>
              <Row className="body-margin">
                <Col sm={12} className="text-center">
                  <h3>Retirados</h3>
                </Col>
                <Col sm={12} className="text-center">
                  <PaginationHeaderYear year={props.year} changeHeader={this.changeHeader} />
                </Col>
                <Col sm={12} className="text-right">
                  <ClipLoader css={override} size={23} color={"#36D7B7"} loading={this.state.loading} />
                  <Button color="primary" className="mr-2" onClick={() => this.rechargeData()}>
                    Recargar
                  </Button>
                </Col>
                <Col sm={12}>
                  <Datatable
                    data={props.dataRetired}
                    columns={COLUMNS_RETIRED()}
                    keyProp="per_cedula"
                    exportD={false}
                    searchs={true}
                    selectRows={false}
                    optionSelectRow={null}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default Retired;
